<template>
	<div class="meeting-search">
		<div>
			<search :keyWords="searchKeyWord" :url="url" @goSearch="getSearchMeetings"></search>
		</div>
		<div class="meetingList ">
			<template v-for="item in searchMeetings">
				<item-block :itemContent="item"></item-block>
			</template>
		</div>
		<div class="meetingList recommend">
			<h3>推荐会议</h3>
			<template v-for="item in recommendMeetings">
				<item-block :itemContent="item"></item-block>
			</template>
		</div>		
	</div>
</template>
<script>
	import Search from '../../components/Search';
	import ItemBlock from '../../components/ItemBlock';
	import {MeetingsSearch,MeetingsPlaceSearch,MeetingsRecommend} from '../../config/interface.js'
	export default{
		components:{
			Search,
			ItemBlock
		},
		data(){
			return{
				searchKeyWord:'',
				searchMeetings:[],
				recommendMeetings:[],
				url:'MeetingCalendar'
			}
		},
		mounted(){
			this.searchKeyWord=this.$route.query.searchKeyWord;
			this.$route.query.id?this.id=this.$route.query.id:this.id=0;
			this.getSearchMeetings(this.searchKeyWord,this.id);
			this.getRecommendMeetings();
		},
		methods:{
			//搜索关键词会议
			getSearchMeetings(searchKeyWord,id){
				this.$store.dispatch('isShowLoading',true);
				let url=id?MeetingsPlaceSearch:MeetingsSearch;
				const method='POST';
				let params=id?{region_id:id}:{keywords:searchKeyWord}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						let searchMeetings=[];
						data.forEach((item,index)=>{
							item.start_at=((item.start_at.split(' ')[0]).split('-')).join('.');
							let end_at_arr=(item.end_at.split(' ')[0]).split('-');
							item.end_at=end_at_arr[1]+'.'+end_at_arr[2];
							searchMeetings.push(item);
						})
						this.searchMeetings=searchMeetings;		
					}
					this.$store.dispatch('isShowLoading',false);
				})

			},
			//推荐会议
			getRecommendMeetings(){
				const url=MeetingsRecommend;
				const method='POST';
				let params={};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						let recommendMeetings=[];
						data.forEach((item,index)=>{
							item.start_at=((item.start_at.split(' ')[0]).split('-')).join('.');
							let end_at_arr=(item.end_at.split(' ')[0]).split('-');
							item.end_at=end_at_arr[1]+'.'+end_at_arr[2];
							recommendMeetings.push(item);
						})
						this.recommendMeetings=recommendMeetings;
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.meeting-search{
		.meetingList{
			padding:0px 12px;
		}
		h3{
			font-size:17px;
			color:$color-black;
			letter-spacing: 0.6px;
			margin-top: 0.373333rem;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/meeting/search.vue